export const formatCurrency: (
    options: Omit<Intl.NumberFormatOptions, "style"> | undefined,
) => (value: number | bigint) => string = (opts) => (value) => {
    try {
        return new Intl.NumberFormat("nb", {
            style: "currency",
            currency: "EUR",
            currencyDisplay: "narrowSymbol",
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
            ...opts,
        }).format(value);
    } catch {
        return formatCurrency({ ...opts, currency: "EUR" })(value);
    }
};
